module.exports = __webpack_public_path__ + "img/call-icon.svg";